/**
 * GENERATED FILE -- DO NOT EDIT.
 *
 * Written by scripts/gen_search_registry.py from search-registry.json, which is
 * the single source of truth shared with the backend (search/config.py) and the
 * eval harness (scripts/search_eval/score_search.py).
 *
 * To change any value here, edit search-registry.json and re-run:
 *     python3 scripts/gen_search_registry.py
 *
 * CI runs `--check`; a hand-edit here will fail the build.
 */

export const SEARCH_TYPES = [
  'Standard',
  'Directive',
  'Policy',
  'OtherPolicy',
  'Charter',
  'Delegation',
  'Definition',
  'Acronym',
  'Person',
];

export const SEARCH_PAGE_SIZE = 50;

export const SITE_CHOICES: Array<{ value: string; label: string }> = [
  {
    value: 'standards',
    label: 'Technical Standards',
  },
  {
    value: 'directives',
    label: 'Directives',
  },
  {
    value: 'nnsa',
    label: 'NNSA',
  },
];

export const SITE_BASE_URLS: Record<string, string> = {
  standards: 'https://archives.standards.doxcelerate.com',
  directives: 'https://archives.directives.doxcelerate.com',
  nnsa: 'https://archives.nnsa.doxcelerate.com',
};

export const SEARCH_FACETS: Array<{
  field: string;
  label: string;
  type: 'selectFacet' | 'checkboxFacet' | 'daterangeFacet' | 'archiveFacet';
  multiple?: boolean;
}> = [
  {
    field: 'site',
    label: 'Site',
    type: 'archiveFacet',
    multiple: true,
  },
  {
    field: 'document_category',
    label: 'Category',
    type: 'selectFacet',
  },
  {
    field: 'status',
    label: 'Status',
    type: 'checkboxFacet',
    multiple: true,
  },
  {
    field: 'series',
    label: 'Series',
    type: 'selectFacet',
  },
  {
    field: 'subject_areas',
    label: 'Subject',
    type: 'selectFacet',
    multiple: true,
  },
];

export const SEARCH_COLUMN_CATALOG: Array<{
  field: string | string[];
  resolve?: 'first';
  title: string;
  link?: boolean;
  format?: string;
  default?: boolean;
}> = [
  {
    field: 'docid',
    title: 'Document #',
    link: true,
    default: true,
  },
  {
    field: 'Title',
    title: 'Title',
    link: true,
    default: true,
  },
  {
    field: 'Description',
    title: 'Description',
    default: false,
  },
  {
    field: 'site_label',
    title: 'Site',
    default: true,
  },
  {
    field: 'Type',
    title: 'Type',
    default: false,
  },
  {
    field: 'document_id',
    title: 'Document ID',
    default: false,
  },
  {
    field: 'status',
    title: 'Status',
    format: 'status',
    default: true,
  },
  {
    field: 'document_category',
    title: 'Category',
    default: true,
  },
  {
    field: 'series',
    title: 'Series',
    default: false,
  },
  {
    field: 'subject_areas',
    title: 'Subject',
    default: false,
  },
  {
    field: 'opi',
    title: 'OPI',
    default: false,
  },
  {
    field: 'delegation_type',
    title: 'Delegation Type',
    default: false,
  },
  {
    field: 'definition_type',
    title: 'Definition Type',
    default: false,
  },
  {
    field: [
      'issue_date',
      'authority_effective_date',
    ],
    resolve: 'first',
    title: 'Date',
    format: 'date',
    default: true,
  },
  {
    field: 'effective',
    title: 'Effective',
    format: 'date',
    default: false,
  },
  {
    field: 'updated_date',
    title: 'Updated',
    format: 'date',
    default: false,
  },
  {
    field: 'supersedes_date',
    title: 'Supersedes',
    format: 'date',
    default: false,
  },
  {
    field: 'authority_effective_date',
    title: 'Authority Effective',
    format: 'date',
    default: false,
  },
  {
    field: 'created',
    title: 'Created',
    format: 'date',
    default: false,
  },
  {
    field: 'modified',
    title: 'Modified',
    format: 'date',
    default: false,
  },
];

export const FILTERABLE_FIELDS: readonly string[] = [
  'portal_type',
  'review_state',
  'document_category',
  'status',
  'series',
  'site',
  'subject_areas',
  'opi',
  'delegation_type',
];

export const SORTABLE_FIELDS: readonly string[] = [
  'authority_effective_date',
  'created',
  'docid',
  'document_category',
  'effective',
  'issue_date',
  'modified',
  'series',
  'sortable_title',
  'status',
  'supersedes_date',
  'updated_date',
];

export const STATUS_PARAM = 'status_group';

export const STATUS_DEFAULT_WITH_TERM = 'All';

export const STATUS_DEFAULT_WITHOUT_TERM = 'Current';

export const STATUS_GROUPS: Array<{ id: string; label: string }> = [
  {
    id: 'Current',
    label: 'Current',
  },
  {
    id: 'Archive',
    label: 'Archive',
  },
  {
    id: 'All',
    label: 'All',
  },
];

export const STATUS_RETIRED: readonly string[] = [
  'Archive',
  'Archived',
  'Rescinded',
  'Canceled',
];

export const SEARCH_OPERATORS: readonly string[] = [
  'OR',
  'AND',
];

export const DEFAULT_OPERATOR = 'OR';

export const SUGGEST: {
  limit: number;
  minChars: number;
  debounceMs: number;
} = {
  limit: 8,
  minChars: 2,
  debounceMs: 150,
};

export const FIELD_PREFIXES: Array<{
  alias: string;
  prefixes: readonly string[];
  label: string;
  noun: string;
  hint: string;
  placeholder: string;
}> = [
  {
    alias: 'title',
    prefixes: [
      'title',
      'name',
    ],
    label: 'Title contains',
    noun: 'document titles',
    hint: 'Words in the document title only -- not its text or metadata.',
    placeholder: 'emergency management',
  },
  {
    alias: 'docnum',
    prefixes: [
      'id',
      'number',
      'docid',
    ],
    label: 'Document number',
    noun: 'document numbers',
    hint: 'Matches the whole version family: 1104 finds every DOE-STD-1104.',
    placeholder: 'DOE-STD-1104',
  },
  {
    alias: 'text',
    prefixes: [
      'text',
      'fulltext',
      'body',
    ],
    label: 'Document text contains',
    noun: 'the text inside documents',
    hint: 'Words inside the PDF itself.',
    placeholder: 'criticality safety',
  },
];

export const SORT_DEFAULTS: {
  withTerm: string;
  withoutTerm: string;
  withoutTermOrder: string;
} = {
  withTerm: '',
  withoutTerm: 'issue_date',
  withoutTermOrder: 'descending',
};
